import React from "react";
import { useForm } from "react-hook-form";
import "../css/signup.css";
import "../css/index.css";
import logo from "../img/logo-softmining.svg";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

function Signup() {
    const { signup } = useAuth();
    const navigate = useNavigate();
    const {
        register,
        handleSubmit,
        formState: { errors },
        watch,
    } = useForm();

    const password = watch("password", "");

    const onSubmit = async (data) => {
        try {
            await signup(data);
            alert("Registration successful!");
            navigate("/dashboard");
        } catch (error) {
            if (error.message === "ERROR_DUPLICATE")
                alert(`This user already exist`);
            else
                alert(`Registration failed: ${error.message}`);
        }
    };

    return (
        <div className="form-container">
            <div className="form formSignup">
                <img src={logo} className="sign-logo" alt="logo" />
                <h2 className="titolo TitoloLogin">SIGN UP</h2>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="inputLeft">
                        <label className="text" htmlFor="name">Name</label>
                        <input
                            required
                            id="firstname"
                            name="firstname"
                            type="text"
                            placeholder="Enter your name..."
                            {...register("firstname")}
                        />
                    </div>
                    <div className="inputRight">
                        <label className="text" htmlFor="surname">Surname</label>
                        <input
                            required
                            id="lastname"
                            name="lastname"
                            type="text"
                            placeholder="Enter your surname..."
                            {...register("lastname")}
                        />
                    </div>
                    <label className="text" htmlFor="company">Company</label>
                    <input
                        required
                        id="company"
                        name="company"
                        type="text"
                        placeholder="Enter your company name..."
                        {...register("company")}
                    />

                    <label className="text" htmlFor="email">E-mail</label>
                    <input
                        required
                        id="email"
                        name="email"
                        type="email"
                        placeholder="Enter your email..."
                        {...register("email", {
                            pattern: {
                                value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                                message: "Invalid email address",
                            },
                        })}
                    />
                    {errors.email && <p className="error-message">{errors.email.message}</p>}

                    <p className="password-hint">
                        The password must contain at least 8 characters, one uppercase letter, one special character, and one number.                       </p>
                    <div className="inputLeft">
                        <label className="text" htmlFor="password">Password</label>
                        <input
                            required
                            type="password"
                            id="password"
                            name="password"
                            placeholder="Enter your password..."
                            {...register("password", {
                                minLength: { value: 8, message: "Password must be at least 8 characters" },
                                validate: {
                                    hasNumber: (value) => /\d/.test(value) || "Password must contain a number",
                                    hasSpecialChar: (value) => /[!@#$%^&*]/.test(value) || "Password must contain a special character",
                                    hasCapitalLetter: (value) => /[A-Z]/.test(value) || "Password must contain a capital letter",
                                },
                            })}
                        />
                        {errors.password && <p className="error-message">{errors.password.message}</p>}
                    </div>
                    <div className="inputRight">
                        <label className="text" htmlFor="confirmpassword">Confirm Password</label>
                        <input
                            required
                            type="password"
                            id="confirmpassword"
                            name="confirmPassword"
                            placeholder="Confirm your password..."
                            {...register("confirmPassword", {
                                required: "Please confirm your password",
                                validate: (value) =>
                                    value === password || "Passwords do not match",
                            })}
                        />
                        {errors.confirmPassword && <p className="error-message">{errors.confirmPassword.message}</p>}
                    </div>
                    <button type="submit" className="sign-button button">Sign up</button>
                </form>
                <div className="riga">
                    <Link className="textlink textLinkSign" to="/login">Already have an account? Sign in</Link>
                </div>
            </div>
        </div>
    );
}

export default Signup;
